import './footer.css';

function Footer() {
    return (
        <>
            <div className='footer'>
                <p>Made with ❤️ by <span><a href="https://www.linkedin.com/in/jordi-alejandre-camps-36a9401a7/" target='_blank' rel='noreferrer'>Jordi Alejandre Camps</a></span></p>
            </div>
        </>
    );
}

export { Footer }; 